import React from "react";
import "./headerBar.scss";

import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../ScreenSizeContext";

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const HeaderBar = ({ title, option = true, back = false, path = -1 }) => {
  const navigate = useNavigate();
  const isPC = useScreenSize();

  return (
    <>
      <div className="header-bar-container">
        <div className="wrapper-title-icon">
          {back ? (
            <div
              className="lnr lnr-arrow-left arrow-back"
              onClick={() => navigate(path, { replace: true })}
            ></div>
          ) : null}
          <div
            className="title"
            style={{ fontFamily: title !== "Volunteer" ? null : null }}
          >
            {title}
          </div>
        </div>
        {/*Se sono su un device posso vedere immagine profilo */}
        {option && !isPC && !back ? (
          <div className="options">
            {localStorage.getItem("imageProfile") ? (
              <div
                className="profile-image"
                onClick={() => {
                  navigate("../settings");
                }}
              >
                <img
                  src={localStorage.getItem("imageProfile") ?? "/no_img.png"}
                  alt="profile"
                />
                <div className="settings-icon">
                  <SettingsOutlinedIcon style={{ fontSize: "15px" }} />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {isPC ? <OptionsBoxPCHeaderBar /> : null}
      </div>
    </>
  );
};

const OptionsBoxPCHeaderBar = () => {
  const navigate = useNavigate();
  return (
    <>
      {localStorage.getItem("surname") && localStorage.getItem("name") ? (
        <div className="options">
          <div className="info-user-box" onClick={() => navigate("/settings")}>
            <div className="profile-image">
              <img
                src={localStorage.getItem("imageProfile") ?? "/no_img.png"}
                alt="profile"
              />
            </div>
            <div>
              {localStorage.getItem("name") +
                " " +
                localStorage.getItem("surname")}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default HeaderBar;
